import script from "./LeftHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftHeader.vue?vue&type=script&setup=true&lang=ts"

import "./LeftHeader.vue?vue&type=style&index=0&id=5b44ef0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b44ef0e"]])

export default __exports__